import { Children, FC, isValidElement } from 'react';
import { Column } from './Column';
import { columnsDefaultProps, IColumnsProps } from './Columns.types';
import { ColumnsVisual } from './ColumnsVisual';

export const Columns: FC<IColumnsProps> = ({ children, ...rest }) => {
  Children.forEach(children, child => {
    if (isValidElement(child) && child.type !== Column) {
      throw new Error('Only Column is allowed as a child of Columns');
    }
  });

  return (
    <ColumnsVisual {...columnsDefaultProps} {...rest}>
      {children}
    </ColumnsVisual>
  );
};

Columns.displayName = 'Columns';
